import { Text } from 'app/design/primitives/text';
import { Trans } from 'react-i18next';

export function InviteIntroduction({
  numInvited,
  tPrefix,
  tSuffix,
}: {
  numInvited: number;
  tPrefix: string;
  tSuffix: string;
}) {
  return (
    <>
      <Text fontSize={24} fontWeight="700" lineHeight={32} marginHorizontal="spacing.general.x4">
        <Trans
          components={{ color: <Text color="text.brand" fontSize={24} /> }}
          i18nKey={`${tPrefix}title${tSuffix}`}
          ns="invite"
        />
      </Text>
      <Text fontSize={20} lineHeight={26} marginHorizontal="spacing.general.x4">
        <Trans
          components={{ strong: <Text fontWeight="700" /> }}
          i18nKey={`${tPrefix}details${tSuffix}`}
          ns="invite"
          values={{ numInvited }}
        />
      </Text>
    </>
  );
}
